<template>
  <div class="award">
    <div class="flex-box flex-h-c nav bb">
      <div
        class="flex1 flex-box flex-hv-c"
        :class="{focus:showType==2}"
        @click.stop="changType(2)"
      >全部</div>
      <div
        class="flex1 flex-box flex-hv-c"
        :class="{focus:showType==1}"
        @click.stop="changType(1)"
      >代理</div>
      <div
        class="flex1 flex-box flex-hv-c"
        :class="{focus:showType==0}"
        @click.stop="changType(0)"
      >非代理</div>
    </div>
    <Cloadmore @loadBottom="loadBottom" @loadTop="loadTop" ref="listTopic">
      <ul v-if="list.length>0" v-cloak>
        <li v-for="(item,index) in list" :key="index" class="bb">
          <div class="flex-box">
            <div class="flex2 flex-box flex-v-c">
              <div>
                <img :src="item.headimgurl" alt class="headimgurl" />
              </div>
              <div>
                <div>
                  用户ID：
                  <span class="tip">{{item.userId}}</span>
                </div>
                <div>昵称：{{item.nickname}}</div>
              </div>
            </div>
            <div class="flex1 flex-box flex-v-c flex-h-e">
              是否代理：
              <span
                :class="{success:item.isMember==1,waiting:item.isMember==0}"
              >{{item.isMember==1?'是':'否'}}</span>
            </div>
          </div>
          <div class="flex-box flex-v-c flex-b">
            <div class="flex3">内容：{{item.content}}</div>
            <div class="flex1 flex-box flex-hv-c">
              <div class="button copyContent" @click="copy(item.content)">复制</div>
            </div>
          </div>
          <div class="flex-box flex-v-c flex-h-e time">{{item.createTime | formatDate}}</div>
        </li>
      </ul>
      <div v-else class="nullData">暂无数据~</div>
    </Cloadmore>
  </div>
</template>
<!--javascript-->
<script>
import Cloadmore from '../loadmore/loadmore.vue';
import Clipboard from '../../../static/js/clipboard.min'
export default {
  name: 'memberApply',
  components: { Cloadmore },
  data: function () {
    return {
      loader: false,
      list: [],
      showType: 2,
      lastIndex: "",
      isMember: '',
      dataLength: '',
      lastClickTime: new Date().getTime() - 1300,
      sortListShow: false//控制显示隐藏
    }
  },
  methods: {
    getData(params) {
      var that = this
      var data = {
        lastIndex: that.lastIndex,
        isMember: that.isMember
      }
      // console.log(data)

      this.$http.get('/user/recruitList', {
        params: data
      }).then(function (res) {
        if (res.code == 0) {
          that.loader = true;

          that.dataLength = res.data.list.length;
          // console.log(res.data.list.length)
          if (that.dataLength > 0) {
            that.lastIndex = res.data.list[that.dataLength - 1].id
            for (let i = 0; i < that.dataLength; i++) {
              res.data.list[i].deliveryTime = that.$common.common.formatDate(res.data.list[i].deliveryTime)
              that.list.push(res.data.list[i])
            }

            if (params == 'getNewData') {//下拉 刷新 或者 搜索 时  获取新数据 避免使用清空数组造成的闪屏
              for (let i = 0; i < that.dataLength; i++) { //新数据有多少条
                that.list[i] = res.data.list[i]
              }
              that.list.length = that.dataLength;//截取数组长度
            }
          } else {
            if (that.lastIndex == '') {//切换Tab时第一页没有数据得到情况
              that.list = []
            }
            that.$refs.listTopic.setAllLoaded(true) //关闭上拉加载
            that.$toast({
              message: '没有更多数据', position: 'bottom',
            });
          }
        } else {
          that.$toast(res.message)
        }
      })
    },
    loadTop() {
      let that = this
      that.lastIndex = ''
      that.getData('getNewData')
      setTimeout(function () {
        that.$refs.listTopic.onTopLoaded();
      }, 1000)
      that.$refs.listTopic.setAllLoaded(false) //调用子组件loadmore的函数 开启上拉加载
    },

    loadBottom() {
      let that = this;
      if (!this.loader) {
        return
      }

      setTimeout(function () {
        that.$refs.listTopic.onBottomLoaded();
      }, 1000)
      that.getData()
    },
    changType(param) {
      var clickTime = new Date().getTime()
      // console.log(clickTime - that.lastClickTime)
      if (clickTime - this.lastClickTime > 1300) {
        this.lastClickTime = new Date().getTime()
      } else {
        this.$toast('操作频繁,请稍后再试')
        return
      }
      this.showType = param
      if (param == 2) {
        this.isMember = ''
      } else {
        this.isMember = param
      }
      this.lastIndex = ''
      this.getData('getNewData')
    },
    copy(content) {
      var that = this
      var clipboard = new Clipboard('.copyContent', {
        text: function () {
          return content;
        },
      });
      clipboard.on('success', function (e) {
        that.$toast('内容已复制到剪贴板')
      });
      clipboard.on('error', function (e) {
        that.$toast('复制失败,请手动长按复制')
        that.kefuShow = true
      });
    },
  },
  mounted: function () {
    this.getData()
  },
  created: function () {
  }
}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
.title {
  height: 0.5rem;
  background: linear-gradient(
    90deg,
    #f4f6f6 0%,
    #e4e5e5 22%,
    #d7dbdb 50%,
    #e4e5e5 80%,
    #f4f6f6 100%
  );
}
.headimgurl {
  width: 0.8rem;
  border-radius: 50%;
  margin: 0 8px 0 0;
  border: 1px solid #087e82;
  padding: 1px;
}

.icon-rmb {
  font-size: 0.3rem;
}
.nav {
  height: 0.7rem;
}

.focus {
  border-bottom: 1px solid #087e82;
  color: #087e82;
}

ul {
  li {
    line-height: 1.5;
    padding: 10px;
    min-height: 1.2rem;
  }
}

.sort .iconfont {
  font-size: 0.1rem;
  margin-top: 2px;
  margin-left: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/memberApply/index.vue